export default "__VITE_PUBLIC_ASSET__374d6365__"